/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiningPpsRewardDetailsResponse } from './mining-pps-reward-details-response';


export interface MiningPpsRewardDetailsResponsePagedList { 
    totalCount?: number;
    items?: Array<MiningPpsRewardDetailsResponse> | null;
}

